<form #formulario="ngForm">
    <fieldset class="bordas">
        <mat-accordion>

            <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>Dados da categoria</mat-panel-title>
                </mat-expansion-panel-header>

                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                    <!-- CATEGORIA -->
                    <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                        <mat-label>Categoria:</mat-label>
                        <mat-select [(ngModel)]="parceriasCategorias.categoriasContabeis.id" name="categoriasContabeis"
                            required>
                            <mat-option *ngFor="let e of categoriasContabeis" [value]="e.id">
                                {{e.nome}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="categoriasContabeis?.length === 0" align="start">Nenhuma categoria cadastrada
                        </mat-hint>
                    </mat-form-field>

                    <!-- #VALOR  -->
                    <mat-form-field fxFlexOffset="20px" fxFlex="15%">
                        <input [(ngModel)]="parceriasCategorias.valorParceriaCategoria" currencyMask name="valor"
                            placeholder="Valor:" matInput maxlength="13"
                            [options]="{ prefix: '', thousands: '.', decimal: ',' }" required />
                        <span matPrefix>R$&nbsp;</span>
                    </mat-form-field>

                </div>

               <div style="margin-left: 20px;" *ngIf="parceriasCategorias.aditivosParceriasCategorias.length > 0">
                    Aditivos:
                </div>
              
                <div fxLayout="column" *ngIf="parceriasCategorias.aditivosParceriasCategorias.length > 0" fxFlexFill>
                    <div *ngFor="let aditivo of parceriasCategorias.aditivosParceriasCategorias;index as i" fxFlexFill>
                            <mat-form-field fxFlexOffset="40px" fxFlex="25%">
                                <input [(ngModel)]="aditivo.dataAditivo" 
                                       matInput [ngModelOptions]="{standalone: true}"
                                       [matDatepicker]="dataMovimentacao" 
                                       placeholder="Data do Aditivo" 
                                       (input)="onMascaraDataInput($event)"
                                       required>
                                <mat-datepicker-toggle matSuffix [for]="dataMovimentacao">
                                </mat-datepicker-toggle>
                                <mat-datepicker #dataMovimentacao></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field fxFlexOffset="40px" fxFlex="25%">
                                <input [(ngModel)]="aditivo.valorAditivo" currencyMask [ngModelOptions]="{standalone: true}"
                                    placeholder="Valor do Aditivo:" matInput maxlength="13"
                                    [options]="{ prefix: '', thousands: '.', decimal: ',' }" required />
                                <span matPrefix>R$&nbsp;</span>
                            </mat-form-field>

                            <button mat-button (click)="deletarAditivo(parceriasCategorias,aditivo)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>

                </div>

                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10%; margin-bottom: 10%" fxFlexFill>
                    <button mat-button style="margin-top: 1%;" (click)="adicionarAditivo(parceriasCategorias)">
                        <mat-icon>addchart</mat-icon>
                        novo aditivo.
                    </button>
                </div>


                <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                    style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                    <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                        Limpar
                    </button>

                    <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                        fxFlex="20%" color="primary" (click)="adicionar()">
                        Adicionar Categoria
                    </button>

                    <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid
                        fxFlex="20%" color="primary" (click)="atualizar()">
                        Atualizar Categoria
                    </button>

                </div>

            </mat-expansion-panel>


            <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
                (closed)="openFormCadastro = true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Lista de Materiais dos Parceiros ( {{listaParceriasCategorias?.length}} )
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                    style="margin-top: 20px">

                    <ng-container matColumnDef="categoriasContabeis">
                        <th mat-header-cell *matHeaderCellDef> Categorias </th>
                        <td mat-cell *matCellDef="let element"> {{element.categoriasContabeis?.nome}}</td>
                    </ng-container>

                    <ng-container matColumnDef="valorParceriaCategoria">
                        <th mat-header-cell *matHeaderCellDef> Data Início:</th>
                        <td mat-cell *matCellDef="let element">{{element.valorParceriaCategoria | currency: 'BRL'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="acoes">
                        <th mat-header-cell *matHeaderCellDef> Ações </th>
                        <td mat-cell *matCellDef="let element">
                            <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizarComposicao(element)">
                                <mat-icon>create</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <div [hidden]="!mostrarTabela">
                    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
                </div>

                <ng-template #tabelaSemDados>
                    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                        {{msg}}
                    </div>
                </ng-template>

                <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
                    style="padding-top: 30px">
                    <div>
                        <button matTooltip="Adicionar nova material" mat-fab color="primary" (click)="novo()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-expansion-panel>

        </mat-accordion>
    </fieldset>
</form>